export const getChangesNumberText = (value: number) => {
  return value > 1 ? `${value} changes` : `${value} change`;
};
